<template>
	<div>
		<div v-if="!previewDoc" class="height-100dvh">
			<div
				class="mob-back-header d-flex justify-content-start align-items-center"
			>
				<div class="ml-3 mr-3 mb-1" @click="resetRouterQuery">
					<img src="../../../assets/icons/mobUpldDoc/bck-arrow.svg" />
				</div>
				<div class="docCat-head-txt">{{ allDocs.categoryTitle }}</div>
			</div>
			<div class="mobile-body-uld app-bottom-padding">
				<div>
					<template v-if="shimmerLoader">
						<div
							v-for="i in shimmerLoop"
							:key="i"
							class="base-card-box pl-3 pr-2 py-2 mt-2"
						>
							<div class="" style="padding: 10px">
								<b-skeleton> </b-skeleton>
							</div>
						</div>
					</template>
					<template v-else>
						<div>
							<div
								v-for="(defineDocuments, index1) in allDocs.documents"
								:key="index1 + 'defineDocuments'"
								class="pl-3 pr-2 py-2 mt-2"
								:class="
									defineDocuments.maxSize || defineDocuments.isNotPDF
										? 'base-card-box-err'
										: 'base-card-box'
								"
							>
								<div
									class="d-flex justify-content-between"
									v-if="!defineDocuments.isUploaded"
								>
									<div class="w-75">
										<div class="card-head-dc w-100 text-truncate">
											{{ defineDocuments.documentName }}
										</div>
										<div class="subtxt-dc">(.pdf) max 10 mb</div>
									</div>

									<div
										class="d-flex justify-content-between ucdSelDocFile position-relative"
									>
										<div
											v-if="defineDocuments.maxSize"
											class="error-txt-mob mt-2 mr-2"
										>
											File limit exceeded
										</div>
										<div
											v-else-if="defineDocuments.isNotPDF"
											class="error-txt-mob mt-2 mr-2"
										>
											Failed
										</div>

										<div class="pr-2">
											<img
												src="../../../assets/icons/mobUpldDoc/card-line.svg"
											/>
										</div>
										<!-- {{ defineDocuments.loading }} -->
										<b-overlay
											:show="defineDocuments.loading"
											rounded="sm"
											class="mob-custom-overlay"
										>
											<div>
												<img
													src="../../../assets/icons/mobUpldDoc/upload-doc-mob.svg"
												/>
											</div>
										</b-overlay>
										<b-form-file
											class="mb-2 pointer"
											accept="application/pdf"
											@change="
												handleFileChange($event, index1, defineDocuments)
											"
										>
										</b-form-file>
									</div>
								</div>

								<div class="d-flex justify-content-between" v-else>
									<div class="d-flex align-items-center doc-name-width">
										<div>
											<img
												src="../../../assets/icons/mobUpldDoc/doc-uploaded.svg"
											/>
										</div>
										<div class="card-head-dc ml-1 w-75 text-truncate">
											{{ defineDocuments.documentName }}
										</div>
									</div>
									<div class="d-flex justify-content-between">
										<div
											@click="
												replaceDocument(
													defineDocuments.documentName,
													defineDocuments.document.documentID
												)
											"
											class="px-2"
										>
											<img
												src="../../../assets/icons/mobUpldDoc/replace_mob.svg"
											/>
										</div>
										<div>
											<img
												src="../../../assets/icons/mobUpldDoc/card-line.svg"
											/>
										</div>
										<div
											@click="previewDefineDoc(defineDocuments)"
											class="px-1"
										>
											<img
												src="../../../assets/icons/mobUpldDoc/preview-mob.svg"
											/>
										</div>
										<div>
											<img
												src="../../../assets/icons/mobUpldDoc/card-line.svg"
											/>
										</div>
										<div @click="deleteDefineDoc(defineDocuments)" class="px-1">
											<img
												src="../../../assets/icons/mobUpldDoc/delete-mob.svg"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-for="(otherDocuments, index2) in allDocs.otherDocuments"
							:key="index2 + 'otherDocuments'"
							class="base-card-box pl-3 pr-2 py-2 mt-2"
						>
							<div class="d-flex justify-content-between">
								<div class="d-flex" style="width: 195px">
									<div>
										<img
											src="../../../assets/icons/mobUpldDoc/doc-uploaded.svg"
										/>
									</div>
									<div class="card-head-dc ml-1 mt-1 text-truncate">
										{{ otherDocuments.documentName }}
									</div>
								</div>
								<div class="d-flex justify-content-between">
									<div
										@click.stop="
											replaceDocument(
												otherDocuments.documentName,
												otherDocuments.documentID
											)
										"
										class="px-2"
									>
										<img
											src="../../../assets/icons/mobUpldDoc/replace_mob.svg"
										/>
									</div>
									<div>
										<img src="../../../assets/icons/mobUpldDoc/card-line.svg" />
									</div>
									<div
										@click.stop="previewOtherPdf(otherDocuments)"
										class="px-1"
									>
										<img
											src="../../../assets/icons/mobUpldDoc/preview-mob.svg"
										/>
									</div>
									<div>
										<img src="../../../assets/icons/mobUpldDoc/card-line.svg" />
									</div>
									<div
										@click.stop="deleteOtherDoc(otherDocuments)"
										class="px-1"
									>
										<img
											src="../../../assets/icons/mobUpldDoc/delete-mob.svg"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="base-card-box pl-3 pr-2 py-2 mt-2">
							<div
								class="d-flex justify-content-between"
								@click="openOtherDocumentModal(allDocs)"
							>
								<div>
									<div class="card-head-dc">Other Documents</div>
									<div class="subtxt-dc">(.pdf) max 10 mb</div>
								</div>
								<div class="d-flex justify-content-between">
									<div class="pr-2">
										<img src="../../../assets/icons/mobUpldDoc/card-line.svg" />
									</div>
									<div>
										<img
											src="../../../assets/icons/mobUpldDoc/other-docs-mob.svg"
										/>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div v-else>
			<PreviewDocument @showDoc="closePreview" :pdfLink="pdfLink" />
		</div>
		<DocumentsDelete :documentID="documentID" @updateDoc="updateDoc" />
		<DocumentsUpload
			:otherModal="otherModal"
			:defineDocName="defineDocName"
			:categoryID="categoryID"
			:defineDocReferenceID="defineDocReferenceID"
			:documentID="documentID"
			@updateDoc="updateDoc"
		/>
	</div>
</template>

<script>
import PreviewDocument from "../Documents/PreviewDocument.vue";
import candidateDocsListMixin from "../../../views/CandidateDocuments/CandidateDocsListMixin.js";
import DocumentsDelete from "../../../views/CandidateDocuments/DocumentsDeleteModal.vue";
import DocumentsUpload from "../../../views/CandidateDocuments/DocumentsUploadModal.vue";
import toast from "../../../components/mixin/toast";

export default {
	mixins: [candidateDocsListMixin, toast],

	components: {
		PreviewDocument,
		DocumentsDelete,
		DocumentsUpload,
	},
	props: {
		allDocs: Object,
		selectedIndex: Number,
		shimmerLoader: Boolean,
	},
	data() {
		return {
			pdfLink: {
				link: "",
				name: "",
			},
			documentID: "",
			shimmerLoop: 10,
			defineDocName: "",
			otherModal: false,
			openUploadModal: false,
			openReplaceModal: false,
			previewDoc: false,
			openDeleteModal: false,
			categoryID: "",
			defineDocReferenceID: "",
			maxSize: false,
			selectedFile: null,
			selectedFileName: "",
		};
	},
	watch: {
		allDocs(newVal) {
			console.log(newVal);
		},
	},
	created() {
		if (this.$router.query != null) {
			this.$emit("showDocsPage", true);
		}
	},
	methods: {
		resetRouterQuery() {
			this.$emit("showDocsPage", false);
			this.$router.push({ query: null });
		},
		replaceDocument(docName, ID) {
			this.documentID = ID;
			this.otherModal = false;
			this.$bvModal.show("candidateUploadDocuments");
			this.defineDocName = docName;
		},

		async handleFileChange(event, index, defineDocuments) {
			this.$set(defineDocuments, "loading", false);
			console.log("Define Doc ", defineDocuments);
			this.defineDocReferenceID = defineDocuments.referenceID;
			this.selectedFileName = defineDocuments.documentName;

			const file = event.target.files[0];
			if (file && file.size > 10 * 1024 * 1024) {
				this.$set(defineDocuments, "loading", false);
				this.$set(defineDocuments, "maxSize", true);
				this.errorModal("File size exceeds 10 MB");
				return;
			}
			this.$set(defineDocuments, "maxSize", false);

			const isNotPDF = file.type !== "application/pdf";
			this.$set(defineDocuments, "isNotPDF", isNotPDF);

			if (isNotPDF) {
				this.errorModal("Error", "Please upload PDF file");
				this.$set(defineDocuments, "loading", false);
				return;
			}

			this.$set(defineDocuments, "loading", true);
			this.selectedFile = file;
			this.i1 = index;
			await this.uploadDocs();
			this.$set(defineDocuments, "loading", false);
		},
		deleteOtherDoc(data) {
			console.log("deleteDefineDoc", data);
			this.openDeleteModal = true;
			this.documentID = data.documentID;
			this.deleteDoc(this.documentID);
		},
		deleteDefineDoc(data) {
			this.documentID = data.document.documentID;
			this.deleteDoc(this.documentID);
		},
		previewOtherPdf(data) {
			this.previewDoc = true;
			this.pdfLink.link = data.documentSource[0];
			this.pdfLink.name = data.documentName;
		},
		previewDefineDoc(data) {
			this.previewDoc = true;
			this.pdfLink.link = data.document.documentSource[0];
			this.pdfLink.name = data.documentName;
		},
		closePreview(val) {
			this.previewDoc = val;
		},
	},
};
</script>

<style>
.doc-name-width {
	width: 200px !important;
}
.mob-custom-overlay .spinner-border {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: -0.125em;
	border: 0.25em solid currentcolor;
	border-right-color: transparent;
	border-left-color: rgb(126, 122, 122);
	border-top-color: rgb(126, 122, 122);
	border-bottom-color: rgb(126, 122, 122);
	border-radius: 50%;
	-webkit-animation: 0.75s linear infinite spinner-border;
	animation: 0.75s linear infinite spinner-border;
}
.docCat-header {
	width: 100%;
	height: 8%;
	background: #ffffff;
}
.docCat-head-txt {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 18px;
	color: #000000;
}
.base-card-box {
	/* width: 343px; */
	height: 47px;
	background: #ffffff;
	border-radius: 4px;
}
.base-card-box-err {
	height: 47px;
	background: #ffffff;
	border-radius: 4px;
	border: 1px solid #eb0002;
}
.card-head-dc {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #3a3c40;
}
.subtxt-dc {
	font-family: "Montserrat";
	font-weight: 400;
	font-size: 8px;
	color: #475467;
}
.error-txt-mob {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 10px;
	color: #eb0002;
}
</style>
